const headerCn = {
  brand: '乡村集市',
  top: {
    bazarList: '集市',
    help: '帮助',
    contact: '联系',
  },
  nav: {
    dailyBazar: '杂货',
    medicineBazar: '药品',
    foodBazar: '新鲜食品',
    grains: '谷物',
    nationalBazar: '全国',
    garmentsBazar: '服装',
    cosmeticsBazar: '化妆品',
    bookBazar: '书籍',
    nurseryBazar: '苗圃',
    electronicsBazar: '电子产品',
    chemicalBazar: '化学品',
    hardwareBazar: '五金',
    serviceBazar: '服务',
    feedBazar: '动物饲料',
  },
  search: {
    placeholder: '您在寻找什么商品？'
  },
  drawer: {
    home: '首页',
    dailyBazar: '日常集市',
    medicineBazar: '药品集市',
    grains: '谷物集市',
    nationalBazar: '全国集市',
    foodBazar: '新鲜食品',
    bookBazar: '书籍集市',
    nurseryBazar: '苗圃集市',
    garmentsBazar: '服装集市',
    electronicsBazar: '电子产品集市',
    chemicalBazar: '化学品集市',
    hardwareBazar: '五金集市',
    cosmeticsBazar: '化妆品集市',
    serviceBazar: '服务集市',
    feedBazar: '饲料集市',
  },
  profileMenu: {
    login: '登录',
    register: '注册',
    myAccount: '我的账户',
    storeDashboard: '商店仪表板',
    adminDashboard: '管理员仪表板',
  },
};

export default headerCn;
